import { when, compose, equals, last, split, dropLast } from 'ramda'

/**
 * Takes an IRI and extracts the id value from it.
 * If the IRI is invalid, it will return null.
 *
 * @type {Function}
 */
const extractIdFromIri = compose(
  when(Number.isNaN, () => null),
  Number,
  last,
  split('/'),
  when(compose(equals('/'), last), dropLast(1)),
)

export default extractIdFromIri
